module.exports = __webpack_public_path__ + "static/media/ru.aa72df6b.svg";